import { FC } from 'react';
import classNames from 'classnames';

import type { MeetChatMessage } from '../../../features/meet/chat/types';

import { MeetChatComposer } from './meet-chat-composer';
import { MeetChatMessageList } from './meet-chat-message-list';
import { CloseButton } from '../../../shared/ui';

interface MeetChatPanelProps {
  isOpen: boolean;
  messages: MeetChatMessage[];
  draft: string;
  isSendingImage?: boolean;
  disabled?: boolean;
  onDraftChange: (value: string) => void;
  onSend: () => void | Promise<boolean>;
  onImageSelect: (file: File) => void | Promise<boolean>;
  onClose: () => void;
}

export const MeetChatPanel: FC<MeetChatPanelProps> = ({
  isOpen,
  messages,
  draft,
  isSendingImage = false,
  disabled = false,
  onDraftChange,
  onSend,
  onImageSelect,
  onClose,
}) => {
  if (!isOpen) {
    return null;
  }

  return (
    <div
      className={classNames(
        'fixed z-[70] flex flex-col overflow-hidden bg-white shadow-overlay',
        'inset-x-0 bottom-[60px] top-0 w-full max-w-none rounded-none border-0',
        'pt-[env(safe-area-inset-top,0px)]',
        'sm:inset-x-auto sm:left-3 sm:right-auto sm:top-3 sm:bottom-[65px] sm:w-[min(100%,400px)] sm:max-w-[calc(100vw-24px)] sm:rounded-card sm:border sm:border-line-strong',
        'md:w-[440px] md:max-w-[calc(100vw-32px)] md:rounded-card',
        'lg:w-[560px]',
      )}
      role="dialog"
      aria-label="Чат встречи"
    >
      <div className="flex shrink-0 items-center justify-between border-b border-line px-3 py-2.5 sm:px-4 sm:py-3">
        <p className="truncate pr-2 text-ui-strong text-ink sm:text-body-l-strong">Чат встречи</p>
        <CloseButton label="Закрыть чат" className="shrink-0" onClick={onClose} />
      </div>

      <MeetChatMessageList messages={messages} />
      <MeetChatComposer
        draft={draft}
        isSendingImage={isSendingImage}
        disabled={disabled}
        onDraftChange={onDraftChange}
        onSend={onSend}
        onImageSelect={onImageSelect}
      />
    </div>
  );
};
